module.exports = __webpack_public_path__ + "img/measurement_info_left_band_front_animated.9a3ffd35.gif";